/**
 * Resolves geographic bboxes displayed by stop preload debug overlays (no MapLibre).
 */

import { MAP_STOPS_MIN_PRELOAD_ZOOM, MAP_STOPS_PRELOAD } from "../../../config/global.configuration";
import type { StopBbox, StopViewportContext } from "../stops/stopPreload.types";
import {
    computeStopPrefetchBboxFromContext,
    shrinkBboxFromCenter,
} from "../stops/stopPreloadBbox.tools";

export interface StopsPreloadDebugBboxes {

    /** Blue overlay: last preloaded extent or projected next-fetch bbox. */
    "prefetchDisplayBbox": StopBbox | null;

    /** Amber overlay: inner comfort zone inside preloaded bbox. */
    "shrinkDisplayBbox": StopBbox | null;
}

/**
 * Computes bbox values for debug layer updates from preload store state and viewport.
 *
 * @param context Current viewport snapshot.
 * @param preloadedBbox Last successfully preloaded bbox, if any.
 * @returns Display bboxes or null when preload is inactive (below min zoom).
 */
export const resolveStopsPreloadDebugBboxes = (
    context: StopViewportContext,
    preloadedBbox: StopBbox | null,
): StopsPreloadDebugBboxes => {
    if ( context.currentZoom < MAP_STOPS_MIN_PRELOAD_ZOOM ) {
        return {
            "prefetchDisplayBbox": null,
            "shrinkDisplayBbox":   null,
        };
    }

    const prefetchDisplayBbox = preloadedBbox ?? computeStopPrefetchBboxFromContext( context );
    const shrinkDisplayBbox   = preloadedBbox === null
        ? null
        : shrinkBboxFromCenter( preloadedBbox, MAP_STOPS_PRELOAD.prefetchTriggerShrinkFactor );

    return {
        prefetchDisplayBbox,
        shrinkDisplayBbox,
    };
};
